import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IMenuItem} from "../../../navigation.interface";
import {ActivatedRoute, Router} from "@angular/router";
import {NavigationService} from "../../../navigation.service";

@Component({
    selector: 'db-menu-table-row',
    templateUrl: './menu-table-row.component.html',
    styleUrls: ['./menu-table-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MenuTableRowComponent implements OnInit {

  @Input('menu') set productData(data: IMenuItem) {
    if (!data) {
      return;
    }
    this.menu = data;
  }

  @Input() menuUrl: string = '';

  @Output() removeItem: EventEmitter<number> = new EventEmitter<number>();

  menu: IMenuItem;
  menuItems: string;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.menuItems = this.menu.items.map(item => this._navigationService.decodeHtml(item.title)).join(', ');
  }

  onRemoveItem() {
    this.removeItem.emit(this.menu.id);
  }

  navigateToEditMenu(menuId: number | undefined) {
    if (menuId) {
      this._router.navigate([`./edit-menu/${menuId}`], {relativeTo: this._route});
    }
  }

}
